import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
// import logo from "../../assets/images/logo.png";
import NewLogo from "../../assets/images/new_logo.png";
import RightArrow from "../../assets/svg/arrow-right-white.svg";
import profile from "../../assets/images/profile.jpg";
import cartIcon from "../../assets/images/Cart.png";
import pencilIcon from "../../assets/images/pencil.png";
import locationIcon from "../../assets/images/location.png";
import { userLogin, verifyUserOTP, getUserDetailsById } from "../../Services/UserService";
import { GetCart } from "../../Services/CartService";
import LocationModal from "../Header/LocationModel"; // Adjust path if needed


const Header = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [loginData, setLoginData] = useState(null);
  const [cartCount, setCartCount] = useState(0);

  const [currentLocation, setCurrentLocation] = useState("Find my location");
  const [locationLoading, setLocationLoading] = useState(false);
  const [showLocationModal, setShowLocationModal] = useState(false);
  const [isLocationSet, setIsLocationSet] = useState(false);

  const [isOpen, setIsOpen] = useState(false);

  const location = useLocation();

  const isComingSoonPage = ["/coming-soon"].includes(location.pathname);

  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") setIsOpen(false);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  const autoFetchLocation = () => {
    if (!navigator.geolocation) return;

    setLocationLoading(true);
    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude, longitude } = position.coords;
        localStorage.setItem("latitude", latitude);
        localStorage.setItem("longitude", longitude);

        try {
          const API_KEY = "b20adba3a72241948593ece1f0e8f68e";
          const response = await fetch(
            `https://api.geoapify.com/v1/geocode/reverse?lat=${latitude}&lon=${longitude}&apiKey=${API_KEY}`
          );
          const json = await response.json();
          if (json.features && json.features.length > 0) {
            const formattedAddress = json.features[0].properties.formatted;
            setCurrentLocation(formattedAddress);
            setIsLocationSet(true);
            localStorage.setItem("currentLocation", formattedAddress);
          } else {
            setCurrentLocation("Location Selected");
            setIsLocationSet(true);
            localStorage.setItem("currentLocation", "Location Selected");
          }
        } catch (err) {
          console.error("Error reverse geocoding auto location:", err);
          setCurrentLocation("Location Selected");
          setIsLocationSet(true);
          localStorage.setItem("currentLocation", "Location Selected");
        } finally {
          setLocationLoading(false);
        }

        // Dispatch event to refresh products
        window.dispatchEvent(new CustomEvent("locationFetched"));
      },
      (error) => {
        console.error("Auto location fetch error:", error);
        setLocationLoading(false);
        setShowLocationModal(true);
      },
      { enableHighAccuracy: true, timeout: 8000, maximumAge: 0 }
    );
  };

  useEffect(() => {
    const token = localStorage.getItem("authToken");
    setIsLoggedIn(!!token);

    if (token) {
      fetchCartCount();
    }

    const storedLocation = localStorage.getItem("currentLocation");
    if (storedLocation) {
      setCurrentLocation(storedLocation);
      setIsLocationSet(true);
    } else {
      setIsLocationSet(false);
      autoFetchLocation();
    }
  }, []);

  useEffect(() => {
    const handleOpenLocationModal = () => {
      setShowLocationModal(true);
    };
    window.addEventListener("openLocationModal", handleOpenLocationModal);
    return () => window.removeEventListener("openLocationModal", handleOpenLocationModal);
  }, []);

  useEffect(() => {
    const syncUserCoordinates = async () => {
      const userId = localStorage.getItem("userId");
      if (!userId) return;

      const storedLat = localStorage.getItem("latitude");
      const storedLng = localStorage.getItem("longitude");

      if (!storedLat || !storedLng) {
        try {
          const response = await getUserDetailsById(userId);
          if (response.data && response.data.latitude && response.data.longitude) {
            localStorage.setItem("latitude", response.data.latitude);
            localStorage.setItem("longitude", response.data.longitude);
            window.dispatchEvent(new CustomEvent("locationFetched"));
          }
        } catch (err) {
          console.error("Error syncing user coordinates:", err);
        }
      }
    };

    if (isLoggedIn) {
      syncUserCoordinates();
    }
  }, [isLoggedIn]);

  const fetchCartCount = async () => {
    try {
      const userId = localStorage.getItem("userId");
      if (!userId) return;

      const response = await GetCart({ userId: parseInt(userId), shoppingCartTypeId: 2 });
      if (response.status && response.data) {
        const totalCount = response.data.reduce((sum, item) => sum + (item.quantity || 0), 0);
        setCartCount(totalCount);
      }
    } catch (err) {
      console.error("Error fetching cart count:", err);
    }
  };

  useEffect(() => {
    const handleCartUpdate = () => {
      const token = localStorage.getItem("authToken");
      if (token) {
        fetchCartCount();
      }
    };
    window.addEventListener("cartUpdated", handleCartUpdate);
    return () => window.removeEventListener("cartUpdated", handleCartUpdate);
  }, []);

  const handlePhoneNumberChange = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    if (value.length <= 10) {
      setPhoneNumber(value);
      setError(null);
    }
  };

  const handleLogin = async (e) => {
    e?.preventDefault?.();

    if (!phoneNumber || phoneNumber.length !== 10) {
      setError("Please enter a valid 10-digit mobile number");
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const fullPhoneNumber = `${phoneNumber}`;
      const encodedPhoneNumber = encodeURIComponent(fullPhoneNumber);

      const response = await userLogin(encodedPhoneNumber);

      if (response.status === true || response.statusCode === 200) {
        setLoginData({
          phoneNumber: response.data.phoneNumber,
          randomCode: response.data.randomCode,
        });

        const loginModalElement = document.getElementById("loginModal");
        const loginModal = window.bootstrap
          ? window.bootstrap.Modal.getInstance(loginModalElement)
          : null;
        if (loginModal) loginModal.hide();

        // Cleanup backdrops before showing the next modal to avoid duplicates
        const backdrops = document.querySelectorAll('.modal-backdrop');
        backdrops.forEach(backdrop => backdrop.remove());
        document.body.classList.remove('modal-open');
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';

        const otpModalElement = document.getElementById("otpModal");
        const otpModal = window.bootstrap
          ? (window.bootstrap.Modal.getInstance(otpModalElement) || new window.bootstrap.Modal(otpModalElement))
          : null;
        if (otpModal) otpModal.show();

        setPhoneNumber("");
        setError(null);
      } else {
        setError(response.message || "Login failed. Please try again.");
      }
    } catch (err) {
      console.error("Login error:", err);
      setError(err.response?.data?.message || err.message || "An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleOtpChange = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    setOtp(value);
    setError(null);
    setSuccess(null);
  };

  const handleVerifyOTP = async (e) => {
    e?.preventDefault?.();

    if (!otp || otp.length < 4) {
      setError("Please enter a valid OTP");
      return;
    }

    if (!loginData || !loginData.phoneNumber || !loginData.randomCode) {
      setError("Session expired. Please login again.");
      return;
    }

    setLoading(true);
    setError(null);
    setSuccess(null);

    try {
      const response = await verifyUserOTP(otp, loginData.phoneNumber, loginData.randomCode);

      if (response.status === true || response.statusCode === 200) {
        if (response.data && response.data.token) {
          localStorage.setItem("authToken", response.data.token);
          localStorage.setItem("userId", response.data.id);
          localStorage.setItem("phoneNumber", response.data.phoneNumber);
          localStorage.setItem("userName", response.data.name);
          localStorage.setItem("email", response.data.email);
          localStorage.setItem("razorpayCustomerId", response.data.razorpayCustomerId);
        }

        window.dispatchEvent(new Event('cartUpdated'));

        setSuccess(response.message || "Login successful!");
        setIsLoggedIn(true);

        setTimeout(() => {
          const otpModalElement = document.getElementById("otpModal");
          const otpModal = window.bootstrap
            ? window.bootstrap.Modal.getInstance(otpModalElement)
            : null;
          if (otpModal) otpModal.hide();

          // Full modal cleanup
          const backdrops = document.querySelectorAll('.modal-backdrop');
          backdrops.forEach(backdrop => backdrop.remove());
          document.body.classList.remove('modal-open');
          document.body.style.overflow = '';
          document.body.style.paddingRight = '';

          setOtp("");
          setError(null);
          setSuccess(null);
          setLoginData(null);
        }, 1500);
      } else {
        setError(response.message || "OTP verification failed. Please try again.");
      }
    } catch (err) {
      console.error("OTP Verification error:", err);
      setError(err.response?.data?.message || err.message || "An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleLoginModalClose = () => {
    setPhoneNumber("");
    setError(null);
    setLoading(false);

    // Cleanup backdrops and restore page scroll/clicking
    const backdrops = document.querySelectorAll('.modal-backdrop');
    backdrops.forEach(backdrop => backdrop.remove());
    document.body.classList.remove('modal-open');
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
  };

  const handleOtpModalClose = () => {
    setOtp("");
    setError(null);
    setSuccess(null);
    setLoading(false);
    setLoginData(null);

    // Cleanup backdrops and restore page scroll/clicking
    const backdrops = document.querySelectorAll('.modal-backdrop');
    backdrops.forEach(backdrop => backdrop.remove());
    document.body.classList.remove('modal-open');
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
  };

  const handleGetLocation = () => {
    setShowLocationModal(true);
  };

  const handleRemoveLocation = () => {
    localStorage.removeItem("currentLocation");
    localStorage.removeItem("latitude");
    localStorage.removeItem("longitude");
    setCurrentLocation("");
    setIsLocationSet(false);
    setShowLocationModal(true);
  };

  const handleEnableLocation = () => {
    setShowLocationModal(true);
  };

  const HeaderMenu = [
    { name: "Home", path: "/" },
    { name: "Shop", path: "/shop" },
    { name: "Customize Wheat", path: "/customize-wheat" },
    { name: "About Us", path: "/about-us" },
    { name: "Contact Us", path: "/contact-us" },
  ];

  // Function to clear XML-related keys from localStorage
  const clearXmlRelatedKeys = () => {
    localStorage.removeItem('customise-mainProductXml');
    localStorage.removeItem('customise-productsXml');
    localStorage.removeItem('customise-grindingSelection');
    localStorage.removeItem('customise-quantities');
    localStorage.removeItem('customise-selectedProducts');
    localStorage.removeItem('customise-wheatProductId');
  };

  // Check if current page is a step page (customization related)
  const isStepPage = location.pathname.startsWith('/customize-wheat');

  const handleNavClick = (e, itemPath) => {
    setIsOpen(false);
    if (isStepPage) clearXmlRelatedKeys();

    const protectedPaths = ["/shop", "/customize-wheat", "/cart"];
    const hasLocation = !!localStorage.getItem("currentLocation") && !!localStorage.getItem("latitude");

    if (protectedPaths.includes(itemPath) && !hasLocation) {
      e.preventDefault();
      setShowLocationModal(true);
    }
  };

  return (
    <>
      <nav className="navbar navbar-expand-lg p-0 position-fixed w-100 z-3">
        <div className="container">
          <div className={"nav-background d-flex align-items-center w-100"}>
            <div className="d-flex align-items-center">
              <button
                className="navbar-toggler"
                type="button"
                aria-controls="navbarNav"
                aria-expanded={isOpen}
                aria-label="Toggle navigation"
                onClick={() => setIsOpen((s) => !s)}
              >
                <span className="navbar-toggler-icon" />
              </button>

              <Link className="navbar-brand ms-2" to={"/"} onClick={() => setIsOpen(false)}>
                <img src={NewLogo} alt="Refined Grains" className="logo img-fluid" />
              </Link>
            </div>

            {!isComingSoonPage && (
              <>
                <div className={`collapse navbar-collapse ${isOpen ? "show" : ""}`} id="navbarNav">
                  <ul className="navbar-nav mx-auto">
                    {HeaderMenu.map((item, idx) => (
                      <li className={"nav-item"} key={idx}>
                        <NavLink
                          to={item.path}
                          className="nav-link"
                          onClick={(e) => handleNavClick(e, item.path)}
                        >
                          {item.name}
                        </NavLink>
                      </li>
                    ))}
                  </ul>
                </div>

                <div
                  className="d-flex align-items-center mr_20 current-location"
                  style={{ cursor: locationLoading ? "wait" : "pointer" }}
                  onClick={handleGetLocation}
                >
                  <img src={pencilIcon} alt="pencil_icon" className="pencil-icon cart-img" />

                  <span className="location-text mx-2">{currentLocation.length > 20 ? `${currentLocation.substring(0, 20)}...` : currentLocation}</span>

                  <img src={locationIcon} alt="location_icon" className="cart-img" />
                </div>

                <div className="d-flex align-items-center mr_20 header-cart">
                  <NavLink to="/cart" className="cart-icon position-relative border-0 bg-transparent" onClick={(e) => handleNavClick(e, "/cart")}>
                    <img src={cartIcon} alt="cart_icon" className="cart-img" />
                    <span className="cart-badge">{cartCount}</span>
                  </NavLink>
                </div>

                <div className={"d-flex align-items-center"}>
                  {!isLoggedIn ? (
                    <button className="login-btn" data-bs-toggle="modal" data-bs-target="#loginModal">
                      Login
                    </button>
                  ) : (
                    <Link
                      to={"/my-order"}
                      className={"profile-img ml_14"}
                      onClick={() => { if (isStepPage) clearXmlRelatedKeys(); }}
                    >
                      <img src={profile} alt="user_profile" className={"user-img"} />
                    </Link>
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      </nav>

      {/* Location Permission Popup (Modal) - RETAINED for static fallback */}
      <div
        className="modal fade"
        id="locationPopup"
        tabIndex={-1}
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content p-4">
            <h4 className="mb-3">Location Permission Required</h4>
            <p>We need your location to show products specific to your area. Please enable location or enter it manually.</p>

            <div className="d-flex justify-content-end gap-3 mt-4">
              <button
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>

              <button
                className="btn btn-primary"
                onClick={handleEnableLocation}
              >
                Enable Location
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Login Modal */}
      <div
        className="modal fade"
        id="loginModal"
        tabIndex={-1}
        aria-labelledby="loginModalLabel"
        aria-hidden="true"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="login">
              <div className="login-header mb_80 d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center">
                  <h5 className={'fs_20 fw_400 text-black m-0 me-2'}>Welcome to</h5>
                  <img src={NewLogo} alt="Refined Grains" className="logo" />
                </div>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={handleLoginModalClose}
                ></button>
              </div>

              <div className="login-body">
                <h2 className={'fs_55 fw_500 text-black lh-1 mb_98'}> Log in </h2>
                <label className="label d-block fs_24 fw_600 mb_38">Enter your mobile number</label>

                <div className="mobile-input-wrapper d-flex align-items-center">
                  <div className="country-code-box mr_32">
                    <span className="fw-bold fs_20 fw_600 pb_10 d-block">+91</span>
                  </div>
                  <input
                    type="text"
                    placeholder="Mobile number"
                    className="mobile-number-input"
                    value={phoneNumber}
                    onChange={handlePhoneNumberChange}
                    maxLength={10}
                    disabled={loading}
                  />
                </div>

                {error && (
                  <div className="text-danger mt-3">
                    <p className="mb-0">{error}</p>
                  </div>
                )}

                <button
                  className={'button btn-solid text-uppercase mt_68 d-block mx-auto'}
                  onClick={handleLogin}
                  disabled={loading || !phoneNumber || phoneNumber.length !== 10}
                  style={{
                    cursor: loading || !phoneNumber || phoneNumber.length !== 10 ? 'not-allowed' : 'pointer',
                    opacity: loading || !phoneNumber || phoneNumber.length !== 10 ? 0.6 : 1,
                  }}
                >
                  {loading ? "LOADING..." : "CONTINUE"}
                  <img src={RightArrow} alt="Refined Grains" className="img-fluid ml_10" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* OTP Modal */}
      <div
        className="modal fade"
        id="otpModal"
        tabIndex={-1}
        aria-labelledby="otpModalLabel"
        aria-hidden="true"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="login">
              <div className="login-header mb_80 d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center">
                  <h5 className={'fs_20 fw_400 text-black m-0 me-2'}>Welcome to</h5>
                  <img src={NewLogo} alt="Refined Grains" className="logo" />
                </div>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={handleOtpModalClose}
                ></button>
              </div>

              <div className="login-body">
                <h2 className={'fs_55 fw_500 text-black lh-1 mb_98'}> Verification </h2>
                <label className="label d-block fs_24 fw_600 mb_38">Enter your OTP</label>

                {loginData?.phoneNumber && (
                  <div className="whatsapp-info mb_30 p-3" style={{
                    backgroundColor: '#e8f5e8',
                    border: '1px solid #d4edda',
                    borderRadius: '8px',
                    color: '#155724',
                    fontSize: '16px',
                    lineHeight: '1.5'
                  }}>
                    <strong>📱 Check your WhatsApp</strong><br />
                    <span>OTP sent to {loginData.phoneNumber}</span><br />
                  </div>
                )}

                <div className="mobile-input-wrapper d-flex align-items-center">
                  <div className="country-code-box mr_32">
                    <span className="fw-bold fs_20 fw_600 pb_10 d-block">OTP</span>
                  </div>
                  <input
                    type="text"
                    placeholder="Enter OTP"
                    className="mobile-number-input"
                    value={otp}
                    onChange={handleOtpChange}
                    maxLength={6}
                    disabled={loading}
                  />
                </div>

                {error && (
                  <div className="text-danger mt-3">
                    <p className="mb-0">{error}</p>
                  </div>
                )}

                {success && (
                  <div className="text-success mt-3">
                    <p className="mb-0">{success}</p>
                  </div>
                )}

                <button
                  className={'button btn-solid text-uppercase mt_68 d-block mx-auto'}
                  onClick={handleVerifyOTP}
                  disabled={loading || !otp}
                  style={{
                    cursor: loading || !otp ? 'not-allowed' : 'pointer',
                    opacity: loading || !otp ? 0.6 : 1,
                  }}
                >
                  {loading ? "VERIFYING..." : "SUBMIT"}
                  <img src={RightArrow} alt="Refined Grains" className="img-fluid ml_10" />
                </button>
              </div>
            </div>
          </div>
        </div >
      </div >
      {/* Mobile Floating Cart */}
      <div className="mobile-cart">
        <NavLink to="/cart" className="cart-btn">
          <img src={cartIcon} alt="Cart" className="cart-img" />
          {cartCount > 0 && <span>{cartCount}</span>}
        </NavLink>
      </div>

      {/* ✅ NEW LOCATION MODAL COMPONENT */}
      < LocationModal
        showLocationModal={showLocationModal}
        setShowLocationModal={setShowLocationModal}
        setCurrentLocation={setCurrentLocation}
        setIsLocationSet={setIsLocationSet}
        locationLoading={locationLoading}
        setLocationLoading={setLocationLoading}
        defaultFetchLocation={true}
        currentLocation={currentLocation}
        isLocationSet={isLocationSet}
        onRemoveLocation={handleRemoveLocation}
      />
      
    </>
  );
};

export default Header;